/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {isNotNil} from 'ramda';

import type {
  ConfiguratorBundleResponseBody,
  EvaluationItemResponseBody,
} from '@dms/api/new-vehicle';
import {getNewVehicleEnumLabel, type NewVehicleLabelGroup} from '@dms/features/new-vehicle';
import i18n from '@dms/i18n';

import {getVariantLabel} from './getVariantLabel';

export const STANDARD_INCLUSION = 'STANDARD' as const;
export const OPTIONAL_INCLUSION = 'OPTIONAL' as const;

export const newVehicleLabel = (group: NewVehicleLabelGroup, value: string) =>
  getNewVehicleEnumLabel(group, value, (key, defaultValue) => i18n.t(key, {defaultValue}));

export const getEvaluationLineLabel = (
  item: EvaluationItemResponseBody,
  bundle: ConfiguratorBundleResponseBody,
  t: (key: string, defaultValue: string) => string
) => {
  if (item.type === 'variant') {
    const variantLabel = getVariantLabel(item.id, bundle);
    if (isNotNil(variantLabel)) {
      return variantLabel;
    }
  } else {
    const namedItem = [
      ...bundle.colours,
      ...bundle.upholsteries,
      ...bundle.features,
      ...bundle.packages,
    ].find(({id}) => id === item.id);
    if (namedItem !== undefined) {
      return namedItem.name;
    }
  }

  return t('entity.newVehicle.labels.unknownItem', 'Unknown item');
};
